import React from "react";
import { View, StyleSheet } from "react-native";
import Text from "./DsText";
import { tokens, sharedStyles } from "./tokens";

// Small status pill (TP rows, rack chips, roster rows).
// `tone` is a key of tokens.pill: toRack | inProgress | racked | disabled,
// or any PartnerRoutingAndPacking state (packed, neutral, …).

const Pill = ({ label, tone = "toRack", testID }) => {
  const palette = tokens.pill[tone] || tokens.pill.toRack;
  return (
    <View
      testID={testID}
      style={[
        sharedStyles.pillBase,
        styles.pill,
        { backgroundColor: palette.bg, borderColor: palette.border },
      ]}
    >
      {
        // variant="caption_4" is NotoSansDevanagari-SemiBold — a real semi-
        // bold font file. Pairing a variant with an extra `fontWeight`
        // style makes Android fake-bold an already Regular/SemiBold
        // Devanagari typeface, which drops tail glyphs on Hindi text — the
        // variant alone carries the weight.
      }
      <Text variant="caption_4" style={[styles.text, { color: palette.fg }]}>
        {label}
      </Text>
    </View>
  );
};

export default Pill;

const styles = StyleSheet.create({
  // flexShrink 0 keeps the pill at its text width inside a flex:1 column.
  pill: { paddingVertical: 4, flexShrink: 0, alignSelf: "flex-start" },
  text: { fontSize: 11, letterSpacing: 0.3, flexShrink: 0 },
});
